





import { computed, defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import { AgeStatus, isAdult } from "@/lib/ageHelpers";
import providers from "@/lib/api";
import { toDateOnlyISO } from "@/lib/time";
import config from "@/config";
import AgeConfirmationDeclined from "./components/AgeConfirmationDeclined";
import AgeConfirmationForm from "./components/AgeConfirmationForm";

export default defineComponent({
  name: "AgeConfirmation",
  components: { AgeConfirmationDeclined, AgeConfirmationForm },
  setup() {
    const { authUserStrict, allowAccess } = useAuthUser();
    const { ageStatus, dateOfBirth, setDateOfBirth } = useNSFWUserSettings();

    // lives until the logout, so every login gives one more attempt to enter the birth date
    const declined = ref(false);

    // a user who has not finished the sign up yet is asked after that
    const required = computed(() => config.featureNSFW && allowAccess.value);
    // an unknown age is not asked for, otherwise an adult would see the form until the data is loaded
    const isAgeUnconfirmed = computed(() => [AgeStatus.MISSING, AgeStatus.MINOR].includes(ageStatus.value));
    const showDeclined = computed(() => required.value && declined.value);
    const showForm = computed(() => required.value && isAgeUnconfirmed.value && !declined.value);

    const submitAge = async (value: string, cb?: () => void) => {
      try {
        const newDateOfBirth = toDateOnlyISO(value);
        await providers.UserPublicDataProvider.userPublicInformationUpdate({
          userId: authUserStrict.value.id,
          dateOfBirth: newDateOfBirth,
        });
        setDateOfBirth(newDateOfBirth);
        declined.value = !isAdult(newDateOfBirth);
      } finally {
        cb && cb();
      }
    };

    return { dateOfBirth, showForm, showDeclined, submitAge };
  },
});
